<div fxLayout="row" fxLayoutAlign='space-between center'>
<h3 appMargin marginB="0">Award Letter</h3>

</div>

	<hr>

<div class="ui vertical basic segment">
	<ng-template ngFor let-document [ngForOf]="documents" let-i="index" >
	<div fxLayout="row" fxLayoutAlign='space-between center' [ngClass]="{'selected-row':i == 1}">
		<div fxFlex="grow">
			<h4 class="sub-header"><label class="ui circular teal label" *ngIf="i == 1">Responded</label> {{document?.name}}</h4>
			<div class="sub-item">Date Created <label class="ui circular label">{{document?.dateCreated}}</label>  &nbsp; &nbsp;  &nbsp; &nbsp; Created By <label class="ui circular label">{{document?.createdBy}}</label></div>
		</div>
		<div fxFlex="20%" class="text-right"><a class="ui primary tiny button" >View</a></div>
		<div fxFlex class="text-right"><button class="ui light tiny icon button dropdown" [ngClass]="{'basic primary link':i == 1}" suiDropdown>
			<i class="ellipsis vertical icon"></i>
			<div class="left menu" suiDropdownMenu >
                <div class="item" (click)="sendEmail()">Send as Email</div>
                <div class="item"  (click)="deleteDoc()">Delete Document</div>
                 <div class="item" >Download as PDF</div>
				 <div class="item">Download as MSWord</div>
                </div>
		</button></div>
	</div>
	<div class="ui divider"></div>
	</ng-template>

</div>
